const Screen = ({ screen }) => {
  return (
    <div className="screen">
      <div className="actual-screen">{screen}</div>
    </div>
  );
};

export default Screen;
